export default function checkForPremiumIcon(is_locked) {
  if (is_locked?.display_icon) {
    return true;
  } else {
    return false;
  }
}
